import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Product} from '../../../../../model/product/product';
import {NewProductSlider} from '../../../../../data/slider';
import {ProductService} from "../../../../../service/product-service/product.service";
import {UserService} from "../../../../../native/user/service/user.service";


@Component({
  selector: 'app-product-box-vertical-slider',
  templateUrl: './product-box-vertical-slider.component.html',
  styleUrls: ['./product-box-vertical-slider.component.scss']
})
export class ProductBoxVerticalSliderComponent implements OnInit,AfterViewInit{
  @Input() title: string = 'New Product'; // Default
  @Input() products : Product[] = [];
  @Output() eProductDetail: EventEmitter<any>;

  public newProductSliderConfig: any = NewProductSlider;
  public maxSlider: number;

  constructor(
      public productService: ProductService,
      public userService: UserService
  ) {
    this.eProductDetail = new EventEmitter<any>();
    this.maxSlider = 0;
  }
  ngOnInit(): void {
    this.maxSlider = this.products.length <= 1 ? this.products.length : (this.products.length / 2);
  }

  ngAfterViewInit(): void {
    window.dispatchEvent(new Event('resize'));
    setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 1000);
  }
  onGotoDetail(){
    this.eProductDetail.emit();
  }

  getPrice(product): number{
    return product.itemSupplierList.filter(supplier => supplier.isDefault).map(supplier => supplier.supplierPrice)[0] || 0;
  }


}
